// machine keys used with default fields that should be used with UI
export const KEY_ALLOW_LIST = [
    'label',
    'placeholder',
    'required',
    'isRequired',
    'type',
];
